import { acquireRealtime } from "./realtime-hub.js";

/** 变更通知触发合并补读；正常每60秒校对，断线10秒降级，重连立即补齐。 */
export class ChatRealtimeClient {
  constructor(options) {
    this.options = options; this.closed = false; this.state = "CONNECTING";
    this.running = null; this.pending = false; this.timer = null;
    this.visibilityTarget = options.visibilityTarget || globalThis.document;
    this.onVisibility = () => { if (!this.visibilityTarget?.hidden) void this.refresh(true); };
    // 默认时钟经globalThis调用，避免Chrome的Illegal invocation中断连接装配。
    this.delay = options.delay || ((callback, ms) => globalThis.setTimeout(callback, ms));
    this.cancel = options.cancel || (timer => globalThis.clearTimeout(timer));
  }
  connect() {
    if (!this.options.token || this.lease || this.closed) return;
    this.visibilityTarget?.addEventListener?.("visibilitychange", this.onVisibility);
    this.lease = acquireRealtime({ ...this.options,
      onReady: () => this.refresh(true),
      onEvent: event => { this.options.onEvent?.(event); return this.refresh(); },
      onState: state => {
        const wasConnected = this.state === "CONNECTED";
        this.state = state; this.options.onState?.(state);
        if (!this.timer || wasConnected !== (state === "CONNECTED") || ["REJECTED", "CLOSED"].includes(state)) this.schedule();
      },
    });
    this.schedule();
  }
  refresh(full = false) {
    if (this.closed || ["REJECTED", "CLOSED"].includes(this.state)) return Promise.resolve();
    this.pending = true; this.fullRecovery = this.fullRecovery || full;
    if (this.running) return this.running;
    const operation = Promise.resolve().then(async () => {
      for (let i = 0; i < 8 && this.pending && !this.closed; i++) {
        this.pending = false;
        const full = Boolean(this.fullRecovery); this.fullRecovery = false;
        await this.options.onRefresh?.(full);
      }
    }).catch(error => { if (!this.closed) this.options.onError?.(error); }).finally(() => {
      this.running = null;
      if (this.pending && !this.closed) this.schedule(250, false);
    });
    this.running = operation; return operation;
  }
  schedule(ms = this.state === "CONNECTED" ? 60000 : 10000, full = true) {
    this.cancel(this.timer); this.timer = null;
    if (this.closed || ["REJECTED", "CLOSED"].includes(this.state)) return;
    this.timer = this.delay(async () => { this.timer = null; await this.refresh(full); if (!this.pending) this.schedule(); }, ms);
  }
  close() {
    this.visibilityTarget?.removeEventListener?.("visibilitychange", this.onVisibility);
    this.closed = true; this.pending = false; this.cancel(this.timer); this.timer = null;
    this.lease?.close(); this.lease = null;
  }
}
